<script>
	import showdown from "showdown";
	import { VueEditor } from "vue2-editor";
  import {mapGetters} from "vuex";

	const converter = new showdown.Converter({
		smartIndentationFix: true,
		simpleLineBreaks: true
	});

	export default {
		name: "BaseStylableTextarea",
		components: {
			VueEditor
		},
		props: {
			placeholder: { type: String, required: false, default: "" },
			value: { type: String, required: false, default: "" },
			autofocus: { type: Boolean, required: false, default: false },
			tooltip: { type: Object, required: false, default: null},
      nullable: {type: Boolean, required: false, default: false }
		},
		data() {
			return {
				customToolbar: [
					["bold", "italic"],
					[{ list: "ordered" }, { list: "bullet" }]
				],
				editorOptions: {
					theme: "bubble",
					modules: {
						keyboard: {
							bindings: {
								// disable the use of tabs and emit a tabbulation event for table to intercept
								tab: {
									key: 9,
									handler() {
										return true;
									}
								},
								"remove tab": {
									key: 9,
									shiftKey: true,
									collapsed: true,
									prefix: /\t$/,
									handler() {
										return true;
									}
								}
							}
						}
					}
				},
				htmlValue: null
			};
		},
		computed: {
			idBase() {
				if (this.tooltip) return this.tooltip.target;
				return "bs_" + String(Math.floor(Math.random() * 300));
			},
      ...mapGetters(["computedPrintableLang"]),
		},
		watch: {
			value: {
				handler() {
					if (typeof this.value == "string" && (this.nullable || this.value.length > 0)) {
						let value = this.value;
						value = value.replace(/<br \/>/g, "\n");

						this.htmlValue = this.turnToHtml(value);
					}
				},
				immediate: true
			},
			htmlValue: {
				handler(newValue) {
					this.$emit("input", this.turnToMarkdown(newValue));
				},
				immediate: true
			}
		},
		mounted() {
			if (this.autofocus) {
				this.toggleEditor();
			}
		},
		methods: {
			toggleEditor() {
				this.$nextTick(() => {
					// eslint-disable-next-line no-unused-expressions
					this.$refs.editor?.quill?.focus();
				});
			},
			turnToHtml(value) {
				if (!value || value.length === 0) {
					return "";
				}

				let _value = value;

				// Bugfix bold
				_value = _value.replaceAll("\\*\\*", "**");
				//_value = _value.replaceAll(" **", "**");
				//_value = _value.replaceAll("** ", "**");

				// Bugfix italic
				_value = _value.replaceAll("\\*", "*");
				//_value = _value.replaceAll(" *", "*");
				//_value = _value.replaceAll("*  ", "*");

				_value = _value.replace(/&nbsp;/g, "<br>");

				_value = converter.makeHtml(_value);

				_value = _value.replace(/(\r\n|\n|\r)/gm, "").trim();

				_value = _value.replace(/<br \/>/g, "<p><br></p>");
				_value = _value.replace(/<p><br><\/p><p><br><\/p>/g, "<p><br></p>");

				return _value;
			},
			turnToMarkdown(value) {
				if (!value) {
					return "";
				}

				let _value = converter.makeMarkdown(value);

				_value = _value.replace(/<!-- -->/g, "");
				// eslint-disable-next-line no-useless-escape
				_value = _value.replace("/\*\*/g", "**");

				_value = _value.trim();

				// _value = _value.includes('\n\n') ? _value.replace(/(\n)+$/g, '\n') : _value;
				// _value = _value.replace(/<br>/g, '\n\n');
				// _value = _value.replace(/\n$/, '');

				return _value;
			}
		}
	};
</script>

<template lang="html">
	<div :id="idBase" class="stylable-textarea">
		<VueEditor
			:ref="`editor${idBase}-${computedPrintableLang.key}`"
      :key="`editor${idBase}-${computedPrintableLang.key}`"
			v-model.lazy="htmlValue"
			:editor-toolbar="customToolbar"
			:editor-options="editorOptions"
			:placeholder="placeholder"
			@focus="toggleEditor"
		/>
		<b-tooltip
			v-if="tooltip"
			placement="left"
			:target="tooltip.target"
			container="body"
		>	
			{{ tooltip.text}}
		</b-tooltip>
	</div>
</template>

<style lang="scss">
	@import "~quill/dist/quill.bubble.css";
	@import "../../scss/variables.scss";

	.stylable-textarea {
		cursor: text;
		&.billing__input {
			padding: 0;
		}

		.ql-editor {
			min-height: 0;
			padding: 8px 16px 8px 8px;
			font-size: $font-size-normal;
			height: auto;
			font-family: Roboto, sans-serif;
		}

		.ql-container {
			height: auto;
		}

		.ql-tooltip {
			z-index: 100;
		}
		.ql-editor.ql-blank::before {
			left: 8px;
		}
	}
	.dummy_input.ql-editor {
		display: block;
		padding: 8px 16px 8px 8px;
		width: 100%;
		height: 100%;
		white-space: pre;
		font-size: $font-size-normal;
	}
	.placeholder {
		color: rgba(0, 0, 0, 0.6);
		font-style: italic;
	}
</style>
